const TOKEN_FIELD_SELECTOR = '[name="recaptcha_token"]';
const ERROR_SELECTOR = "[data-recaptcha-error]";
const DEFAULT_ACTION = "website_form";
const DEFAULT_ERROR_MESSAGE =
	"We could not verify that submission. Please try again.";

export function getRecaptchaToken(action = DEFAULT_ACTION) {
	if (window.getRecaptchaToken) {
		return window.getRecaptchaToken(action);
	}

	return new Promise((resolve, reject) => {
		if (!window.recaptchaSiteKey || !window.grecaptcha) {
			reject(new Error("reCAPTCHA is not available."));
			return;
		}

		window.grecaptcha.ready(() => {
			window.grecaptcha
				.execute(window.recaptchaSiteKey, { action })
				.then(resolve)
				.catch(reject);
		});
	});
}

export async function addRecaptchaToken(form) {
	const field = form.querySelector(TOKEN_FIELD_SELECTOR);

	if (!field) {
		return;
	}

	const token = await getRecaptchaToken(
		form.getAttribute("data-recaptcha-action") || DEFAULT_ACTION,
	);
	field.value = token;
}

function getErrorContainer(form) {
	const existing = form.querySelector(ERROR_SELECTOR);
	if (existing) {
		return existing;
	}

	const ajaxError = form.querySelector("[data-ajax-error]");
	if (ajaxError) {
		ajaxError.setAttribute("data-recaptcha-error", "");
		ajaxError.setAttribute("role", "alert");
		return ajaxError;
	}

	const field = form.querySelector(TOKEN_FIELD_SELECTOR);
	const container = document.createElement("div");
	container.className =
		"form-field__error-messages form-field--error-messages is-invalid";
	container.setAttribute("data-recaptcha-error", "");
	container.setAttribute("data-recaptcha-error-generated", "");
	container.setAttribute("role", "alert");

	if (field) {
		field.insertAdjacentElement("afterend", container);
	} else {
		form.prepend(container);
	}

	return container;
}

function clearRecaptchaError(form) {
	const container = form.querySelector(ERROR_SELECTOR);
	if (!container) {
		return;
	}

	if (container.hasAttribute("data-recaptcha-error-generated")) {
		container.remove();
	} else {
		container.innerHTML = "";
	}
}

function showRecaptchaError(form, message = DEFAULT_ERROR_MESSAGE) {
	const container = getErrorContainer(form);
	const error = document.createElement("p");
	error.className = "form-field__error-messages-single";
	error.textContent = message;

	container.innerHTML = "";
	container.appendChild(error);
	container.setAttribute("tabindex", "-1");
	container.focus();
}

export default function setupRecaptchaForms() {
	document.querySelectorAll("form[data-recaptcha]").forEach((form) => {
		form.addEventListener(
			"submit",
			async (event) => {
				const field = form.querySelector(TOKEN_FIELD_SELECTOR);

				if (!field) {
					return;
				}

				if (form.getAttribute("data-recaptcha-submitting") === "true") {
					form.removeAttribute("data-recaptcha-submitting");
					return;
				}

				if (typeof form.checkValidity === "function" && !form.checkValidity()) {
					return;
				}

				event.preventDefault();
				event.stopImmediatePropagation();

				try {
					clearRecaptchaError(form);
					await addRecaptchaToken(form);
					form.setAttribute("data-recaptcha-submitting", "true");
					if (form.requestSubmit) {
						form.requestSubmit(event.submitter);
					} else {
						form.submit();
					}
				} catch (error) {
					form.removeAttribute("data-recaptcha-submitting");
					showRecaptchaError(form);
					console.error(error);
				}
			},
			true,
		);
	});
}
